import { Params } from '@angular/router';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';

import { RouterStateUrl } from '@shared/router-state-serializer';

export interface AppState {
  router: RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
};

export const metaReducers: MetaReducer<AppState>[] = [];

export const getRouter = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');
export const getRouterState = createSelector(
  getRouter,
  (state: RouterReducerState<RouterStateUrl>) => !!state && state.state,
);
export const getRouterUrl = createSelector(
  getRouterState,
  (state: RouterStateUrl) => !!state && state.url,
);
export const getRouterData = createSelector(
  getRouterState,
  (state: RouterStateUrl) => !!state && state.data,
);
export const getRouterParams = createSelector(
  getRouterState,
  (state: RouterStateUrl) => !!state && state.params,
);
export const getRouterQueryParams = createSelector(
  getRouterState,
  (state: RouterStateUrl) => !!state && state.queryParams,
);
export const getInnerRouterPath = createSelector(
  getRouterState,
  (state: RouterStateUrl) => !!state && state.innerRouterPath,
);
export const getRouterParamsId = createSelector(
  getRouterParams,
  (params: Params) => !!params && params.id,
);
export const getRouterParamsReportId = createSelector(
  getRouterParams,
  (params: Params) => !!params && params.reportId,
);
export const getRouterQueryParamsModule = createSelector(
  getRouterQueryParams,
  (params: Params) => !!params && params.module,
);
export const getRouterQueryParamsModuleId = createSelector(
  getRouterQueryParams,
  (params: Params) => !!params && params.moduleId,
);
export const getRouterQueryParamsType = createSelector(
  getRouterQueryParams,
  (params: Params) => !!params && params.type,
);
